import { ThemeProps, TRuleWithTheme } from 'styles/theme';
import { combineRules } from 'fela';
import type { TRule } from 'fela';

export const container: TRuleWithTheme = () => ({
    display: 'flex',
    alignItems: 'flex-start',

    marginBottom: '1rem',

    ':last-child': {
        marginBottom: 0,
    },
});

export const elevator: TRuleWithTheme = () => ({
    flexBasis: '50%',
    minWidth: 0,
});

export const businessUnitWrapper: TRuleWithTheme = () => ({
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    flexBasis: '50%',
    minWidth: 0,
    marginLeft: '1rem',
    gap: '0.75rem 1.5rem',
});

export const businessUnit: TRuleWithTheme = () => ({
    minWidth: 0,
});

const paragraph: TRule = () => ({
    lineHeight: '1.5rem',
    fontWeight: 500,

    '&.ant-typography': {
        marginBottom: '0.25rem',
    },
});

export const factoryNumber: TRule = combineRules<ThemeProps, ThemeProps>(paragraph, () => ({
    fontWeight: 700,
    textDecorationLine:"underline",
    textDecorationThickness: '0.1rem',
    ':hover': {
        color: '#f57645',
    },
}));

export const street = paragraph;

export const city: TRule = combineRules<ThemeProps, ThemeProps>(paragraph, ({ theme }) => ({
    color: theme.colors.text,

    '&.ant-typography': {
        marginBottom: 0,
    },
}));
